// How the coach/instructor (activity.organisers) is told about participant changes.
// Stored on the activity as `organiserNotification`; the actual sending is backend side.

export const ORGANISER_NOTIFICATION_ENTRYCLOSED = 'entryclosed'
export const ORGANISER_NOTIFICATION_ALLCHANGES = 'allchanges'

// Activities created before this setting existed have no value, and quiet-until-closed
// is the safer default, so a missing value reads as 'entryclosed' everywhere.
export const ORGANISER_NOTIFICATION_DEFAULT = ORGANISER_NOTIFICATION_ENTRYCLOSED

export const ORGANISER_NOTIFICATION_OPTIONS = [
  { value: ORGANISER_NOTIFICATION_ENTRYCLOSED, label: 'Kun ilmoittautuminen sulkeutuu' },
  { value: ORGANISER_NOTIFICATION_ALLCHANGES, label: 'Kaikista muutoksista' },
]

export const getOrganiserNotification = (activity) =>
  (activity && activity.organiserNotification) || ORGANISER_NOTIFICATION_DEFAULT
